import { render, staticRenderFns } from "./propertyCommunityList.vue?vue&type=template&id=222a8f8e&scoped=true"
import script from "./propertyCommunityList.vue?vue&type=script&lang=js"
export * from "./propertyCommunityList.vue?vue&type=script&lang=js"
import style0 from "./propertyCommunityList.vue?vue&type=style&index=0&id=222a8f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a8f8e",
  null
  
)

export default component.exports